import { MappedImage } from "src/utils/fw";
import { convertLinksUTM, effect, IAMetadata, ISFAssure } from "./dayOne";
import membership from "./membership";
import Podcast from "./Podcast";
import { useEffect } from "preact/hooks";

const ThreatHorizon = () => {
    useEffect(effect("3079a4fa-a6b4-4c84-a529-6e18aa4405cc"), [])
    const links = [
        {
            label: "Threat Horizon 2026: The era of entangled risks",
            href: "https://www.isflive.org/s/article/threat-horizon-2026-the-era-of-entangled-risks",
            target: "_blank",
            width: "38.7%",
            height: "5%",
            left: "11%",
            top: "67.3%",
            onClick: effect("1a050e8e-7ef0-4107-948b-8a9cc5834ab4")
        },
        {
            label: "Threat Horizon 2027: PESTLE Analysis",
            href: "https://www.isflive.org/s/article/threat-horizon-2027-pestle-analysis",
            target: "_blank",
            width: "38.7%",
            height: "5%",
            left: "50.7%",
            top: "67.3%",
            onClick: effect("cc7ccf53-16ef-4ffb-9552-7f6cfd20d726")
        },
        {
            label: "Assessing threat predictions from Threat Horizon 2023, 2024 and 2025",
            href: "https://www.isflive.org/s/article/threat-horizon-review-assessing-threat-predictions-from-threat-horizon-2023-2024-and-2025",
            target: "_blank",
            width: "78.4%",
            height: "5%",
            left: "11%",
            top: "73.3%",
            onClick: effect("7d3714e9-86c1-4f4d-9019-f288f4b30fd1")
        },
        {
            label: "Join the Threat Horizon community",
            href: "https://www.isflive.org/s/topic/0TO0J0000009AODWA2/threat-horizon",
            target: "_blank",
            width: "42.4%",
            height: "5.5%",
            left: "29%",
            top: "83.3%",
            onClick: effect("cf9f5ca0-bd0e-4694-bcf5-277e0ff92edc")
        },
    ].map(convertLinksUTM)

    return <MappedImage links={links} imageStyle="width:unset;" imageURL="https://assets.swoogo.com/uploads/full/4566475-67181ea45b9b2.png">
        <iframe src="https://player.vimeo.com/video/1021738002?autoplay=1" allowfullscreen style={{
            width: "78.4%",
            height: "48.6%",
            left: "11.05%",
            top: "15.85%",
            position: "absolute",
            border: 0
        }} allow="autoplay" />
    </MappedImage>
}

const THMetadata = {
    name: "Threat Horizon",
    dismiss: {
        width: "2%",
        height: "3%",
        left: "87.5%",
        top: "10.5%"
    }
}

const CyberRegulation = () => {
    useEffect(effect("631836f4-6073-4ce6-aa09-d8bb96b31e36"), [])

    const links = [
        {
            label: "Digital Operational Resilience Act (DORA)",
            href: "https://www.isflive.org/s/services-overview/cyber-regulation#DORANIS2",
            target: "_blank",
            width: "78.4%",
            height: "5%",
            left: "11.4%",
            top: "66.7%",
            onClick: effect("969af299-c341-47bf-a1a3-1e37c8f0a68f")
        },
        {
            label: "Network an Informaiton Security 2 (NIS2)",
            href: "https://www.isflive.org/s/services-overview/cyber-regulation#DORANIS2",
            target: "_blank",
            width: "78.4%",
            height: "5%",
            left: "11.4%",
            top: "72.3%",
            onClick: effect("2ed82af9-884e-402b-9d9e-407c73a5c428")
        },
        {
            label: "Cyber Resilience Act (CRA)",
            href: "https://www.isflive.org/s/services-overview/cyber-regulation#CRA",
            target: "_blank",
            width: "78.4%",
            height: "5%",
            left: "11.4%",
            top: "78%",
            onClick: effect("33060721-5cfe-4f67-82fe-383880ebf690")
        },
        {
            label: "Get in touch with our experts - Services SecurityForum",
            href: "mailto:services@securityforum.org?subject=ISF Services enquiry",
            target: "_blank",
            isExternal: true,
            width: "42.4%",
            height: "5.5%",
            left: "30%",
            top: "86.5%",
            onClick: effect("4c675607-5070-4e68-a9a0-17fdea884db0")
        },
    ].map(convertLinksUTM)

    return <MappedImage links={links} imageStyle="width:unset;" imageURL="https://assets.swoogo.com/uploads/full/4566476-67181ea45e4d1.png" />
}

const CRMetadata = {
    name: "Cyber Regulation",
    dismiss: {
        width: "2%",
        height: "3%",
        left: "87.5%",
        top: "10.5%"
    }
}

export default {
    day: new Date("2024-11-12 08:00:00.000-05:00"),
    tvs: [
        [ThreatHorizon, THMetadata],
        [ISFAssure, IAMetadata],
        [CyberRegulation, CRMetadata],
        Podcast(2),
        membership
    ]
}